import React from 'react';
import { Channel_CODE_SET } from '../../../../config/CgmCodeSet';
import { REPORT_TYPE_SET } from '../../../../config/ReportOptionSet';
import Linker from '../../linker/Linker';
import * as path from '../../../../route/PathConfig';
import './ReportInformation.css'

const QueryTypeIcon = (props) => {
  switch (props.query_type) {
    case "BASIC":{
      return(
        <span className="type_basic">
          {props.query_type}
        </span>
      )
    }
    case "BOOLEAN":{
      return(
        <span className="type_bool">
        {props.query_type}
      </span>
      )
    }
    default:
      return null;
  }
}

const ReportTypeIcon = (props) => {
  switch (props.report_type) {
    case "volume":{
      return(
        <span className="type_volu">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "sentiment":{
      return(
        <span className="type_sent">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "source":{
      return(
        <span className="type_sour">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "relation":{
      return(
        <span className="type_wordcloud">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "category":{
      return(
        <span className="type_cate">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "positioningmap":{
      return(
        <span className="type_positioning">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "buzzlist":{
      return(
        <span className="type_buzzlist">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    default:
      return null;
  }
}


const ReportInformation = (props) => {
  return (
    <div id="reportInformation">
      <div id="reportTitBtn">
        <div id="reportTit">리포트 정보 확인</div>
        {props.reportInfo &&
        <div id="manageBtn">
          <Linker path={`${path.REPORTEDIT}/${props.reportInfo.reportID}`}>
            <a className="button purple_line">편집</a>
          </Linker>          
          &nbsp;
          <a className="button purple_line" onClick={()=>props.handleRemoveBtn(props.reportInfo.reportID)}>삭제</a>
          &nbsp;
          {/* <a className="button purple" style={{padding: "9px 20px"}} onClick={()=>props.handleRunBtn(props.reportInfo.reportID)}>실행</a> */}
          <a className="button purple" onClick={()=>props.handleRunBtn(props.reportInfo.reportID)}>실행</a>
        </div>}
      </div>
      {props.reportInfo.content && props.queryData && props.selectedReportQuery.mainQuery && props.selectedReportQuery.subQuery ?
        <div className="buzzReport">
          <table className="buzzTablesty">
            <tr>
                <td colspan="2">
                  <span className="buzzTxt">
                    {props.reportInfo.name}
                  </span>
                  &nbsp;
                  <ReportTypeIcon report_type={props.reportInfo.REPORT_TYPE} />
                  &nbsp;
                  {/* <span class="type_line">라인</span> */}
                </td>
            </tr>
            <tr>
              <td width="14%" className="tit">Date</td>
              <td width="86%">
                {`${JSON.parse(props.reportInfo.content).date[0].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')} ~ ${JSON.parse(props.reportInfo.content).date[1].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`}
              </td>
            </tr>
            <tr>
              <td className="tit">Channel</td>
              <td>
                {JSON.parse(props.reportInfo.content).channels.map((item, index, array) =>{
                  if (index == array.length-1){
                    return(
                      <>{Channel_CODE_SET[item]}</>
                    )
                  }
                  else{
                    return(
                      <>{Channel_CODE_SET[item]},&nbsp;</>
                    )
                  }
                })}
              </td>
            </tr>
            <tr>
              <td className="tit">Base Keyword</td>
                {props.queryData.info.filter(item=>item.queryID==props.selectedReportQuery.mainQuery).map(item=>{
                  return(
                    <td>
                      {/* <strong>{`${item.name} (${item.QUERY_TYPE})`}</strong><br /> */}
                      <strong>{item.name}</strong>&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} /><br />
                      {item.QUERY_TYPE === "BOOLEAN" ?
                        <>{JSON.parse(item.content).boolQuery}</>
                      : <>
                          <strong>AND</strong>&nbsp;&nbsp;&nbsp;
                          {`${JSON.parse(item.content).and.map(item=>{
                            return(
                              `${item}`
                            )
                          })}`}
                          <br />
                          <strong>OR</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {`${JSON.parse(item.content).or.map(item=>{
                            return(
                              `${item}`
                            )
                          })}`}
                          <br />
                          <strong>NOT</strong>&nbsp;&nbsp;&nbsp;
                          {`${JSON.parse(item.content).not.map(item=>{
                            return(
                              `${item}`
                            )
                          })}`}
                        </>
                      }
                    </td>
                  )
                })}
            </tr>
              {props.selectedReportQuery.subQuery.map((subQueryItem,subQueryIndex)=>{
                return(
                  <>
                    {props.queryData.info.filter((item)=>item.queryID==subQueryItem.queryID).map((item, index)=>{
                      return(
                        <tr>
                        <td className="tit">Sub Keyword {subQueryIndex+1}</td>
                        <td>
                          {/* <strong>{`${item.name} (${item.QUERY_TYPE})`}</strong><br /> */}
                          <strong>{item.name}</strong>&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} /><br />
                          {item.QUERY_TYPE === "BOOLEAN" ?
                            <>{JSON.parse(item.content).boolQuery}</>
                          : <>
                              <strong>AND</strong>&nbsp;&nbsp;&nbsp;
                              {`${JSON.parse(item.content).and.map(item=>{
                                return(
                                  `${item}`
                                )
                              })}`}
                              <br />
                              <strong>OR</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              {`${JSON.parse(item.content).or.map(item=>{
                                return(
                                  `${item}`
                                )
                              })}`}
                              <br />
                              <strong>NOT</strong>&nbsp;&nbsp;&nbsp;
                              {`${JSON.parse(item.content).not.map(item=>{
                                return(
                                  `${item}`
                                )
                              })}`}
                            </>
                          }
                        </td>
                        </tr>
                      )
                    })}
                  </>
                )})}
            {/* <tr>
              <td className="tit">Base Query</td>
                {props.queryData.info.filter(item=>item.queryID==props.reportInfo.mainQuery).map(item=>{
                  return(
                    <td>
                      <strong>{`${item.name} (${item.QUERY_TYPE})`}</strong><br />
                      {item.QUERY_TYPE === "BOOLEAN" ?
                        <>{JSON.parse(item.content).boolQuery}</>
                      : <>
                          <strong>AND</strong>&nbsp;&nbsp;&nbsp;
                          {JSON.parse(item.content).and}
                          <br />
                          <strong>OR</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {JSON.parse(item.content).or}
                          <br />
                          <strong>NOT</strong>&nbsp;&nbsp;&nbsp;
                          {JSON.parse(item.content).not}
                        </>
                      }
                    </td>
                  )
                })}
            </tr>
              {props.reportInfo.subQuery.map(subQueryItem=>{
                return(
                  <>
                    {props.queryData.info.filter((item,index)=>item.queryID==subQueryItem.queryID).map((item, index)=>{
                      return(
                        <tr>
                        <td className="tit">Sub Query {index+1}</td>
                        <td>
                          <strong>{`${item.name} (${item.QUERY_TYPE})`}</strong><br />
                          {item.QUERY_TYPE === "BOOLEAN" ?
                            <>{JSON.parse(item.content).boolQuery}</>
                          : <>
                              <strong>AND</strong>&nbsp;&nbsp;&nbsp;
                              {JSON.parse(item.content).and}
                              <br />
                              <strong>OR</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              {JSON.parse(item.content).or}
                              <br />
                              <strong>NOT</strong>&nbsp;&nbsp;&nbsp;
                              {JSON.parse(item.content).not}
                            </>
                          }
                        </td>
                        </tr>
                      )
                    })}
                  </>
                )})} */}
          </table>
        </div>
        :undefined
      }
    </div>
  )
}

export default ReportInformation;